import { render, staticRenderFns } from "./ChangeSkeletonBox.vue?vue&type=template&id=24c61e2d"
import script from "./ChangeSkeletonBox.vue?vue&type=script&lang=js"
export * from "./ChangeSkeletonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports